// VITE_LANDING_URL is injected at build time; default to "" for local dev,
// which resolves to a same-origin absolute path in production (landing and
// every game share one Netlify domain). Shared by AuthWidget and
// BackToLandingLink — the two corner widgets that link back to landing.
// Trailing slash stripped so consumers can always append their own leading
// "/" without risking a double slash — mirrors scripts/build-site.mjs's
// SITE_ORIGIN normalization, which production already goes through.
export function getLandingUrl(): string {
  const url = (import.meta.env.VITE_LANDING_URL as string | undefined) ?? "";
  return url.replace(/\/+$/, "");
}
